import { Component, Input, OnInit } from '@angular/core';
import { Loadable } from '@app/components/pr-loader/ILoadable';
import { NewDao } from '@app/dao/new/new.dao';

export interface News {
  title: string;
  category: string;
  description: string;
  lead: string;
  image: string;
  link: string;
}

@Component({
    selector: 'ea-news',
    templateUrl: './ea-news.component.html',
    styleUrls: ['./ea-news.component.scss'],
    standalone: false
})
export class EaNewsComponent extends Loadable implements OnInit {
  @Input() category: string;
  @Input() vertical = false;
  @Input() fill = false;
  @Input() withSmall = true;

  news: News[] = [];

  constructor(private newDao: NewDao) {
    super();
  }

  get clazz() {
    if (this.vertical) {
      return 'vertical';
    } else if (this.news && this.news.length >= 3 && this.withSmall) {
      return 'grid mbxl mhm grid-col-2 grid-col-sm-2 grid-col-xs-1';
    } else {
      return 'grid mbxl mhm grid-col-1 grid-col-sm-1 grid-col-xs-1';
    }
  }

  ngOnInit() {
    this.newDao.searchNews(this.category).subscribe(news => {
      this.news = news?.map(n => {
        return {
          title: n.title,
          category: n.metadata.category,
          description: n.description,
          lead: n.lead,
          image: n.image,
          link: n.link.replace(
            'https://www.euodia.fr',
            'https://albr.io/accueil',
          ),
        };
      });
    });
  }
}
